import React from 'react';
import { Field } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/serverProxy';
import ListContainerWithUnitsOnHold from 'src/components/BeaconV2Components/ExperimentalLayout/Summary/ListContainerWithUnitsOnHold';
import { SALES_TABLE_HEADER_DISPLAY_NAMES } from 'src/components/BeaconV2Components/ExperimentalLayout/Summary/Sales/constants';
import MetricListContainer from 'src/components/BeaconV2Components/MetricList/MetricListContainer';
import ProductListContainer from 'src/components/BeaconV2Components/MetricList/ProductListContainer';
import { getWeekColumnDefinition } from 'src/components/BeaconV2Components/MetricList/headColumnDefinitions';
import { removeComparisonFormatter } from 'src/components/BeaconV2Components/MetricList/utils';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';

const fields: Field[] = [
  {
    name: 'retailSales',
    displayName: SALES_TABLE_HEADER_DISPLAY_NAMES.RETAIL_SALES
  },
  {
    name: 'unitsSold',
    displayName: SALES_TABLE_HEADER_DISPLAY_NAMES.UNITS_SOLD
  },
  {
    name: 'wholesaleSales',
    displayName: SALES_TABLE_HEADER_DISPLAY_NAMES.WHOLESALE_SALES
  },
  {
    name: 'retailPrice',
    displayName: SALES_TABLE_HEADER_DISPLAY_NAMES.RETAIL_PRICE
  },
  {
    name: 'instockRate',
    displayName: SALES_TABLE_HEADER_DISPLAY_NAMES.INSTOCK_RATE
  },
  {
    name: 'unitsOnHand',
    displayName: SALES_TABLE_HEADER_DISPLAY_NAMES.UNITS_ON_HAND
  }
];

/**
 * Shows the retail sales by product for the sales page
 */
const RetailSalesProductsList = () => {
  const { isProductEntity } = useProductEntity();

  const weekEndingFields = fields.map(removeComparisonFormatter);

  return isProductEntity ? (
    <MetricListContainer
      entityTableHeaderProps={{
        title: 'Retail Sales by Week'
      }}
      indexName="sales"
      sortFieldName="retailSales"
      fields={weekEndingFields}
      headColumnDefinition={getWeekColumnDefinition({
        getTableColumnProps(defaults) {
          return {
            ...defaults,
            style: {
              ...defaults.style,
              width: '220px'
            }
          };
        }
      })}
      postProcessData={(data) => {
        return data.sort((a, b) => b.weekId.localeCompare(a.weekId));
      }}
      useTableDataProps={{
        groupByFieldName: 'weekId',
        filterResponse: () => true,
        itemsPerPage: 100
      }}
      showGrid={false}
    />
  ) : (
    <ListContainerWithUnitsOnHold groupBy="stacklineSku">
      {({ onChangePage, postProcessData, additionalColumnDefs, unitsOnHandRowsLoading }) => (
        <ProductListContainer
          entityTableHeaderProps={{
            title: 'Retail Sales by Product'
          }}
          indexName="sales"
          sortFieldName="retailSales"
          fields={fields.filter((field) => field.name !== 'unitsOnHand')}
          onChangePage={onChangePage}
          postProcessData={postProcessData}
          additionalColumnDefs={additionalColumnDefs}
          loading={unitsOnHandRowsLoading}
        />
      )}
    </ListContainerWithUnitsOnHold>
  );
};

export default RetailSalesProductsList;
